"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generate_time = void 0;
const generate_time = (data, style = 'delimiters', targetCal = 'general') => {
  const startDate = data['startDate'] && typeof data['startDate'] === 'string' ? data['startDate'].split('-') : [];
  const endDate = data['endDate'] && typeof data['endDate'] === 'string' ? data['endDate'].split('-') : [];
  let start = '';
  let end = '';
  let allday = false;
  if (data['startTime'] != null && data['endTime'] != null) {
    // Adjust for timezone, if set (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones for either the TZ name or the offset)
    if (data['timeZoneOffset'] != null && data['timeZoneOffset'] != '') {
      // if we have a timezone offset given, consider it
      start = new Date(startDate[0] + '-' + startDate[1] + '-' + startDate[2] + 'T' + data['startTime'] + ':00.000' + data['timeZoneOffset']);
      end = new Date(endDate[0] + '-' + endDate[1] + '-' + endDate[2] + 'T' + data['endTime'] + ':00.000' + data['timeZoneOffset']);
      start = start.toISOString().replace('.000', '');
      end = end.toISOString().replace('.000', '');
      if (style == 'clean') {
        start = start.replace(/-/g, '').replace(/:/g, '');
        end = end.replace(/-/g, '').replace(/:/g, '');
      }
    } else {
      // if there is no offset, we prepare the time, assuming it is UTC formatted
      start = new Date(startDate[0] + '-' + startDate[1] + '-' + startDate[2] + 'T' + data['startTime'] + ':00.000+00:00');
      end = new Date(endDate[0] + '-' + endDate[1] + '-' + endDate[2] + 'T' + data['endTime'] + ':00.000+00:00');
      if (data['timeZone'] != null && data['timeZone'] != '') {
        // if a timezone is given, we adjust dynamically with the modern toLocaleString function
        const utcDate = new Date(start.toLocaleString('en-US', {
          timeZone: 'UTC'
        }));
        if (data['timeZone'] == 'currentBrowser') {
          data['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
        const tzDate = new Date(start.toLocaleString('en-US', {
          timeZone: data['timeZone']
        }));
        const offset = utcDate.getTime() - tzDate.getTime();
        start.setTime(start.getTime() + offset);
        end.setTime(end.getTime() + offset);
      }
      start = start.toISOString().replace('.000', '');
      end = end.toISOString().replace('.000', '');
      if (style == 'clean') {
        start = start.replace(/-/g, '').replace(/:/g, '');
        end = end.replace(/-/g, '').replace(/:/g, '');
      }
    }
  } else {
    // would be an allday event then
    allday = true;
    start = new Date(Date.UTC(Number(startDate[0]), Number(startDate[1]), -1, Number(startDate[2])));
    let breakStart = start.toISOString().replace(/T(.+)Z/g, '');
    end = new Date(Date.UTC(Number(endDate[0]), Number(endDate[1]) - 1, Number(endDate[2])));
    if (targetCal == 'google' || targetCal == 'microsoft' || targetCal == 'ical') {
      end.setDate(end.getDate() + 1); // increment the day by 1 for Google Calendar, iCal and Outlook
    }
    let breakEnd = end.toISOString().replace(/T(.+)Z/g, '');
    if (style == 'clean') {
      breakStart = breakStart.replace(/-/g, '');
      breakEnd = breakEnd.replace(/-/g, '');
    }
    start = breakStart;
    end = breakEnd;
  }
  const returnObject = {
    'start': start,
    'end': end,
    'allday': allday
  };
  return returnObject;
};
exports.generate_time = generate_time;